/* 
  Color sets:
    - tenant_config - colors and other settings from the server.
    - defaultColors - hardcoded default colors.
    - colors - applied on the frontend.
*/
export const focusColors = ["primary", "secondary", "accent", "neutral"];